﻿import React, { useEffect } from 'react';

import { MultiGenerateReport, ReportTabOption } from 'components/MultiGenerateReport/MultiGenerateReport';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { TileContainer } from 'components/TileContainer/TileContainer';
import { exportPDF } from 'pages/groups/components/Activity';
import { FormattedMessage } from 'react-intl';
import { useJoyride } from 'app/joyride';

// In-code datasource for the report select.
const STUDENT_REPORT_TAB_OPTIONS: ReportTabOption[] = [
    { name: 'Student Activity Report', reportId: 31 },
    { name: 'Student Course Activity', reportId: 75 }
];

interface ActivityProps {
    studentId: number;
}

export function Activity({ studentId }: ActivityProps) {

    const { loadCurrentTour } = useJoyride();

    useEffect(() => {

        loadCurrentTour('ReportsTab');

    }, []);

    return (
        <TileContainer>
            <MultiGenerateReport
                actions={(
                    <GMetrixButton iconClass="fa-solid fa-print" onClick={() => exportPDF()} type="button" variant="primary">
                        <FormattedMessage defaultMessage="Print" id="print.1fd3b13a" />
                    </GMetrixButton>
                )}
                cultureId={1}
                reports={STUDENT_REPORT_TAB_OPTIONS}
                scopeId={8}
                scopeObjectId={studentId}
            />
        </TileContainer>
    );

}
